import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import FacebookLogin from 'react-facebook-login';
import GoogleLogin from 'react-google-login';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class AdminInformation extends Component {

    render() { 
        return ( 
            <div className="showtix-section showtix-background__primary-1">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h1>{strings.administrationInformation}</h1>
                            <p className="showtix-subtitle">{strings.administrationSignIn}</p>
                            <FacebookLogin
                                appId= {process.env.REACT_APP_FACEBOOK_APP_ID}
                                autoLoad={false}
                                fields="name,email"
                                callback={this.props.facebookCallback}
                                cssClass="facebook-login-button"
                                icon="fa-facebook"
                            />
                            <GoogleLogin
                                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                                buttonText="Login"
                                onRequest={this.props.googleButtonOpacityToggle}
                                onSuccess={this.props.googleCallback}
                                onFailure={this.props.googleButtonOpacityToggle}
                                className={this.props.googleButtonFaded ? 'google-login-button faded' : 'google-login-button'}
                            >      
                                <span>
                                    <i className="fa fa-google"></i>
                                    {strings.loginGoogle}
                                </span>
                            </GoogleLogin>
                        </div>
                    </div>
                    <hr className="mt-4 mb-4" />
                    <div className="row">
                        <div className="col-12 text-center">
                            <p className="showtix-subtitle">{strings.administrationCreate}</p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="username">{strings.username}*
                                    <span id="tooltip-username" className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target="tooltip-username">
                                        {strings.usernameTooltip}
                                    </Tooltip>
                                </label>
                                <div className="showtix-form__input">
                                    <input 
                                        className="showtix-input" 
                                        id="username" 
                                        type="text" 
                                        object="admin" 
                                        name="username" 
                                        value={this.props.register.admin.username} 
                                        validation="(^(?!\s*$).+)"
                                        onChange={this.props.handleChange} 
                                        onBlur={this.props.validateRequiredField} 
                                        required
                                    />
                                </div>
                                {!this.props.validation.admin.username.valid &&
                                    <div className=" showtix-note error">
                                        {this.props.validation.admin.username.msg}
                                    </div>
                                }
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="password">{strings.password}*
                                    <span id="tooltip-password" className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target="tooltip-password">
                                        {strings.passwordTooltip}
                                    </Tooltip>
                                </label>
                                <div className="showtix-form__input">
                                    <input className="showtix-input" 
                                        type="password" 
                                        object="admin" 
                                        name="password" 
                                        id="password" 
                                        value={this.props.register.admin.password} 
                                        validation="(^(?!\s*$).+)" 
                                        onChange={this.props.handleChange} 
                                        onBlur={this.props.validateRequiredField}
                                        required
                                    />
                                </div>
                                {!this.props.validation.admin.password.valid &&
                                    <div className=" showtix-note error">
                                        {this.props.validation.admin.password.msg}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="admin_first_name">{strings.firstName}*</label>
                                <div className="showtix-form__input">
                                    <input 
                                        id="admin_first_name" 
                                        className="showtix-input" 
                                        type="text" 
                                        object="admin" 
                                        name="first_name" 
                                        value={this.props.register.admin.first_name} 
                                        validation="(^(?!\s*$).+)"
                                        onChange={this.props.handleChange} 
                                        onBlur={this.props.validateRequiredField}
                                        required 
                                    />
                                </div>
                                {!this.props.validation.admin.first_name.valid &&
                                    <div className=" showtix-note error">
                                    {this.props.validation.admin.first_name.msg}
                                    </div>
                                }
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="admin_last_name">{strings.lastName}*</label>
                                <div className="showtix-form__input">
                                    <input 
                                        className="showtix-input" 
                                        id="admin_last_name"
                                        type="text" 
                                        object="admin" 
                                        name="last_name" 
                                        value={this.props.register.admin.last_name} 
                                        validation="(^(?!\s*$).+)"
                                        onChange={this.props.handleChange} 
                                        onBlur={this.props.validateRequiredField}
                                        required 
                                    />
                                </div>
                                {!this.props.validation.admin.last_name.valid &&
                                    <div className=" showtix-note error">
                                    {this.props.validation.admin.last_name.msg}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className={"showtix-form__group " + (this.props.validation.admin.email.valid === false && this.props.register.admin.email !== '' ? 'showtix-form__error' : '')}>
                                <label className="showtix-label" htmlFor="admin_email">{strings.email}*</label>
                                <div className="showtix-form__input">
                                    <input 
                                        className="showtix-input" 
                                        id="admin_email"
                                        type="text" 
                                        object="admin" 
                                        name="email" 
                                        value={this.props.register.admin.email} 
                                        validation="(^([\w-\.]+@([\w-]+\.)+[\w-]{2,})?$)"
                                        onChange={this.props.handleChange} 
                                        onBlur={this.props.validateRequiredField}
                                        required 
                                    />
                                </div>
                                {!this.props.validation.admin.email.valid &&
                                    <div className=" showtix-note error">
                                    {this.props.validation.admin.email.msg}
                                    </div>
                                }
                            </div>
                        </div>

                        <div className="col-12 col-md-6"></div>
                    </div>
                </div>
            </div>
        )

    }
}

AdminInformation.propTypes = {
    register: PropTypes.shape({
        admin: PropTypes.shape({
            username: PropTypes.string,
            password: PropTypes.string,
            first_name: PropTypes.string,
            last_name: PropTypes.string,
            email: PropTypes.string
        })
    }),
    validation: PropTypes.shape({
        admin: PropTypes.shape({
            username: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            password: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            first_name: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            last_name: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            email: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            })
        })
    }),
    googleButtonFaded: PropTypes.bool,
    isDisabled: PropTypes.bool,
    facebookCallback: PropTypes.func,
    googleButtonOpacityToggle: PropTypes.func,
    googleCallback: PropTypes.func,
    handleChange: PropTypes.func,
    validateRequiredField: PropTypes.func,
}
 
export default AdminInformation;


// WEBPACK FOOTER //
// ./src/components/Registration/AdminInformation/AdminInformation.js